var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E5yACday8zO3fMW06nYQAa",
    x1: 18.921,
    x2: 25.143,
    y1: 520.285,
    y2: 499.285,
    gradientTransform: "matrix(1 0 0 -1 0 526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0858a1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E5yACday8zO3fMW06nYQAa)",
    d: "M43,29.452H5V16.554c0-0.686,0.352-1.325,0.932-1.691l16.466-10.4c0.979-0.618,2.225-0.618,3.204,0l16.466,10.4C42.648,15.23,43,15.868,43,16.554V29.452z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E5yACday8zO3fMW06nYQAb",
    x1: 24,
    x2: 24,
    y1: 512.584,
    y2: 498.767,
    gradientTransform: "matrix(1 0 0 -1 0 526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f8f8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3e3e1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E5yACday8zO3fMW06nYQAb)",
    d: "M38,32H10V14c0-0.552,0.448-1,1-1h26c0.552,0,1,0.448,1,1V32z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E5yACday8zO3fMW06nYQAc",
    x1: 25.886,
    x2: 37.997,
    y1: 498.064,
    y2: 480.731,
    gradientTransform: "matrix(1 0 0 -1 0 526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ccbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1fa0e5"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E5yACday8zO3fMW06nYQAc)",
    d: "M43,17v21.256C43,39.219,42.206,40,41.226,40H9.56l4.803-6.327L43,17z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E5yACday8zO3fMW06nYQAd",
    x1: 3.074,
    x2: 39.962,
    y1: 498.764,
    y2: 480.875,
    gradientTransform: "matrix(1 0 0 -1 0 526)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28afea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b88da"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E5yACday8zO3fMW06nYQAd)",
    d: "M5,17v21.256C5,39.219,5.794,40,6.774,40h34.453c0.56,0,1.053-0.26,1.378-0.658L5,17z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e7d9b9f6.svg";
export { ForwardRef as ReactComponent };